export const LOAD_CART = 'load_cart'
export const ADD_ITEM = 'add_item'
export const REMOVE_ITEM = 'remove_item'
export const UPDATE_ITEM = 'update_item'
export const OPEN_ITEM_ADDED_MODAL = 'open_item_added_modal'
export const CLOSE_ITEM_ADDED_MODAL = 'close_item_added_modal'

export function loadCart() {
  return {
    type: LOAD_CART
  }
}

export function addItem(items) {
  const filteredFields = items.map(item => {
    delete item.__typename
    return {
      ...item
    }
  })
  return {
    type: ADD_ITEM,
    items: filteredFields
  }
}

export function removeItem(id) {
  return {
    type: REMOVE_ITEM,
    id
  }
}
export function updateItem(id, newquantity, items) {
  const newItems = items.map(item => {
    let ID = item.productID ? item.productID : item.productName
    if (ID === id) {
      delete item.__typename
      return { ...item, quantity: newquantity }
    } else {
      return item
    }
  })

  return {
    type: UPDATE_ITEM,
    items: newItems
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/cartActions.js